import React from 'react';
import renderHTML from 'react-render-html';
import { Button } from 'telstra-ui/components/button/Button';
import { Checkbox } from 'telstra-ui/components/checkbox/Checkbox';
import { stripStartingAndEndingPTags } from '../../../ssm-homepage/ssm-homepage.actions';
import { Mobile, Desktop } from '../../../../app-responsive';

const SubmitSection = (props) => {
  const {
    authorableContent: {
      descriptionText,
      ButtonText,
      checkBoxLabel,
      backButtonText,
    },
    onSubmitButton,
    onBackButton,
    onChangCheckBox,
    submitLoader,
    submitBtnDisabled,
    backButton,
    checkBoxState,
    positiveBanner,
  } = props;
  const mobileBack = '<';

  return (
    <div className="row submit-section">
      { descriptionText && positiveBanner &&
        <div className="col-12 paddingXS pl-0 pr-0">
          {renderHTML(stripStartingAndEndingPTags(descriptionText))}
        </div>
      }
      { checkBoxLabel && onChangCheckBox &&
        <div className="col-12 pr-sm-0 checkbox-section">
          <Checkbox
            id="submitCheckbox"
            label={renderHTML(checkBoxLabel)}
            onChange={onChangCheckBox}
            checked={checkBoxState}
          />
        </div>
      }
      {backButton &&
      <React.Fragment>
        <Desktop>
          <div className="col-sm-4 col-md-9 back-btn paddingXS text-center-mobile">
            <Button
              variant="super"
              onClick={onBackButton}
            >
              {backButtonText}
            </Button>
          </div>
        </Desktop>
        <Mobile>
          <div className="col-sm-4 col-md-9 back-btn paddingXS text-center-mobile">
            <Button
              variant="super"
              onClick={onBackButton}
            >
              {mobileBack}
            </Button>
          </div>
        </Mobile>
      </React.Fragment>
      }

      <div className={`col-sm-8 col-md-3 submit-btn paddingXS text-center-mobile ${backButton ? 'text-right' : ''}`}>
        <Button
          variant="super"
          onClick={onSubmitButton}
          state={submitLoader ? 'loading' : 'app'}
          disabled={submitBtnDisabled}
        >
          {ButtonText}
        </Button>
      </div>
    </div>
  );
};

export default SubmitSection;
